// extracted by mini-css-extract-plugin
module.exports = {"inputBlock":"Lz2Uzv","apply":"J_CIDU","reset":"_4ixmIk","suggestions":"SDxqQc","item":"O_Ruwl","title":"MzN9Rz"};